export const convertBoolean = (value) => {
  return value ? 1 : 0;
};
